import {
  GetDoctorSpecialityListActionTypes,
  GET_DOCTOR_SPECIALITY_LIST_FAIL,
  GET_DOCTOR_SPECIALITY_LIST_LOADING,
  GET_DOCTOR_SPECIALITY_LIST_SUCCESS,
  GetDoctorSpecialityListState,
  GET_DOCTOR_SPECIALITY_LIST_UPDATE_API_MSG,
  GET_DOCTOR_SPECIALITY_LIST_UPDATE_API_RES,
} from "./ActionTypes";
import { GetDoctorSpecialistListRes } from "./Model";

const initialStateGetPosts: GetDoctorSpecialityListState = {
  loading: false,
  getDoctorSpecialityListRes: {} as GetDoctorSpecialistListRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getDoctorSpecialityListReducer = (
  state = initialStateGetPosts,
  action: GetDoctorSpecialityListActionTypes
): GetDoctorSpecialityListState => {
  switch (action.type) {
    case GET_DOCTOR_SPECIALITY_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_DOCTOR_SPECIALITY_LIST_SUCCESS:
      return {
        ...state,
        getDoctorSpecialityListRes: action.payload,
        successMsg: action.successMsg,
      };
    case GET_DOCTOR_SPECIALITY_LIST_FAIL:
      return {
        ...state,
        getDoctorSpecialityListRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_DOCTOR_SPECIALITY_LIST_UPDATE_API_MSG:
      return {
        ...state,
        getDoctorSpecialityListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_DOCTOR_SPECIALITY_LIST_UPDATE_API_RES:
      return {
        ...state,
        getDoctorSpecialityListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
